export const BRAND_NAMES: Record<string, string> = {
  everphone: 'Everphone',
  telekom: 'Telekom',
}

export enum ThemesEnum {
  EVERPHONE = 'everphone',
  TELEKOM = 'telekom',
}
